module.exports = __webpack_public_path__ + "img/qyq.ee2e22fa.png";